<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
    <b-container fluid class="mt--6">
       <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-row>
            <b-col sm="12">
                <div class="card-wrapper">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="8">
                                    <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                                </b-col>
                                <b-col cols="4">
                                     <base-button type="success" @click="newStockTransfer" class="float-right">
                                        <i class="fa fa-plus"></i>{{language_terms['NEW_TRANSFER_REQUEST']}}
                                    </base-button>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col md="2" >
                                <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch">
                                </base-input>
                            </b-col>
                            <b-col md="2">
                                <label class="form-control-label">{{language_terms['FROM_LOCATION']}}</label>
                                <locationLookup v-bind:url="apiLocationLookup" v-on:selected="selectFromLocation($event)" :lookupId="filter.from_location_code"/>
                            </b-col>
                            <b-col md="2">
                                <label class="form-control-label">{{language_terms['TO_LOCATION']}}</label>
                                <locationLookup v-bind:url="apiLocationLookup" v-on:selected="selectToLocation($event)" :lookupId="filter.to_location_code"/>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['DATE_FROM']" >
                                <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur" style="background-color: white" class="form-control datepicker" v-model="filter.date_from">
                                </flat-picker>
                              </base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['DATE_TO']" >
                                <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur" style="background-color: white" class="form-control datepicker" v-model="filter.date_to"></flat-picker>
                              </base-input>
                            </b-col>
                            <b-col md="1">
                                <base-input :label="language_terms['STATUS']">
                                <el-select v-model="filter.status" filterable :placeholder="language_terms['STATUS']">
                                    <el-option v-for="option in statusOptions" :key="option.code" :label="language_terms[option.name]" :value="option.code">
                                    </el-option>
                                </el-select>
                                </base-input>
                            </b-col>
                            <b-col cols="1" class="mt-4">
                              <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                          </b-col>
                        </b-row>
                    </b-card>
                    <PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0"/>

                </div>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";

import PaginatedTables from '@/views/Tables/PaginatedTables'
import locationLookup from "@/components/Autocomplete.vue";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

export default {
  components: {
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    PaginatedTables,
    locationLookup
  },
  data() {
    return {
      apiLocationLookup: apiRoutes["LOOKUP_LOCATION_WITH_NO_PARENT"],
      statusOptions:[
        {code:"PENDING", name:"PENDING"},
        {code:"PROVISIONING", name:"PROVISIONING"},
        {code:"PROVISIONED", name:"PROVISIONED"},
        {code:"SENT", name:"SENT"},
        {code:"RECEIVED", name:"RECEIVED"},
        {code:"CANCELLED", name:"CANCELLED"}
      ],
      loading:false,
      filter:
      {
        keyword:"",
        date_from:null,
        date_to:null,
        location_from:"",
        location_to:"",
        from_location_code:"",
        to_location_code:"",
        status:'PENDING'
      },
      tableColumns: [
        {
          prop: "code",
          label: "Code",
          minWidth: 100,
          sortable: true,
          key:"CODE"
        },
        {
          prop: "from_location_name",
          label: "FROM_LOCATION",
          minWidth: 120,
          sortable: true,
          key:"FROM_LOCATION"
        },
        {
          prop: "to_location_name",
          label: "TO_LOCATION",
          minWidth: 120,
          sortable: true,
          key:"TO_LOCATION"
        },
        {
          prop: "date_requested",
          label: "DATE_REQUESTED",
          minWidth: 120,
          sortable: true,
          key:"DATE_REQUESTED"
        },
        {
          prop: "date_sent",
          label: "DATE_SENT",
          minWidth: 100,
          sortable: true,
          key:"DATE_SENT"
        },
        {
          prop: "date_received",
          label: "DATE_RECEIVED",
          minWidth: 100,
          sortable: true,
          key:"DATE_RECEIVED"
        },
        {
            prop: "status",
            label: "STATUS",
            minWidth: 100,
            sortable: true,
            key:"STATUS"
        },
        {
            prop: "creator_user",
            label: "REQUESTOR",
            minWidth: 100,
            sortable: true,
            key:"REQUESTOR"
        }
      ]
    };
  },
  mounted(){
    this.updateTableLang()
  },

  computed:{
    ...mapState({
      language_terms:(state)=>state.languages.language_terms,
      items:(state) => state.stocktransfers.stocktransfers
    })
  },

  watch:{
    language_terms:{
            handler(val){
                this.updateTableLang()
            },
    },
    items:{
      deep: true,
       handler(val){
        this.updateLangVal()
      },

    }
  },
  methods:{
      async selectToLocation(obj)
      {
          let location_id = null;
          let location_code = null;
          let location_name = null;

          if(obj)
          {
            location_id = obj.id
            location_code = obj.code
            location_name = obj.name
          }

          this.filter.to_location_id = location_id
          this.filter.to_location_code = location_code
          this.filter.to_location_name = location_name
      },
      async selectFromLocation(obj)
      {
          let location_id = null;
          let location_code = null;
          let location_name = null;

          if(obj)
          {
            location_id = obj.id
            location_code = obj.code
            location_name = obj.name
          }

          this.filter.from_location_id = location_id
          this.filter.from_location_code = location_code
          this.filter.from_location_name = location_name
      },
      async clickOnSearch()
      {
        await this.$store.dispatch("stocktransfers/quickSearch", this.filter);
        console.log(this.items)
      },
      newStockTransfer()
      {
          this.$router.push("/inventory/stocktransfer/_new")
      },
      updateLangVal()
      {
        // for(let i=0; i< this.items.length;i++)
        // {
        //   this.items[i].status = this.language_terms[this.items[i].status]
        //   console.log(this.items[i].status)
        // }
      },
      updateTableLang()
      {
        for(let i=0; i<this.tableColumns.length;i++)
        {
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
        }
    },

  }
};
</script>


<style>
</style>